import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {boolean} props.isLoading
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode}
 */
export const StepSuspense = ({ isLoading, children }) => {
  return isLoading ? <LoadingIndicator className={styles['loading-indicator']} data-testid='step-suspense' /> : children;
};
